import {HTH} from "../HTH";
import {HTHGameConfig} from "../HTHGameConfig";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";

export class HTHReelAnticipationTop extends PIXI.Container {

    private _playReelAreaOverlay: TimelineSprite;

    constructor() {
        super();
        this.name = "ReelAnticipationTop";
        this.init();

    }


    public reset(): void {
        this._playReelAreaOverlay.hide();
        this._playReelAreaOverlay.stopLoop();
    }

    public playAnticipationReelEffect(): void {
        this._playReelAreaOverlay.show();
        this._playReelAreaOverlay.playLoop();
    }

    private init() {

        this._playReelAreaOverlay = new TimelineSprite(HTH.assetLoader.getTextures("scatterReelAreaAnticipation"));
        this._playReelAreaOverlay.anchor.set(0.5, 0.5);
        this._playReelAreaOverlay.name = "reelAreaHighlight";
        this._playReelAreaOverlay.hide();
        this._playReelAreaOverlay.scale.set(2.15, 2.2);
        this._playReelAreaOverlay.blendMode = PIXI.BLEND_MODES.ADD;
        this._playReelAreaOverlay.position.set(297, 232);
        this.addChild(this._playReelAreaOverlay);


        this.position.set(HTHGameConfig.reelAreaPos.x, HTHGameConfig.reelAreaPos.y);
    }
}